<template>
    <div>

      <div class="center big-padding" style="font-size: 18px;">
        {{errorCancellationMessage}}
      </div>

      <div class="buttons">

        <div class="btn btn-primary" v-on:click=confirm()>
          Ok
        </div>
      </div>
    </div>

</template>

<script>

export default {
  props: [
    'demande',
  ],
  data: function () {
    return {
      texte: '',
    }
  },
  computed: {
    errorCancellationMessage() {
      return this.$store.state.demandes.cancellationError;
    },
  },
  methods: {
    confirm: async function () {
      this.$emit('close')

    },
  }
}
</script>



// WEBPACK FOOTER //
// ErrorModal.vue?49f724a2